export const SPONSOR_LETTER = {
    label: "Sponsor Letter",
    code: "SL"
};

export const CHILD_LETTER = {
    label: "Child Letter",
    code: "CL"
};

const INTRODUCTORY_LETTER = {
    label: "Introductory Letter",
    code: "IL"
};

const GIFT_ACKNOWLEDGEMENT_LETTER = {
    label: "Gift Acknowledgement Letter",
    code: "GAL"
};

const THANK_YOU_LETTER = {
    label: "Thank You Letter",
    code: "TY"
};

const CHILD_EXPRESSION_WORKSHEET = {
    label: "Child Expression Worksheet",
    code: "CEW"
};

const CHRISTMAS_CARD = {
    label: 'Christmas Card',
    code: 'CC'
};

const FAREWELL_LETTER = {
    label: "Farewell Letter",
    code: "FL"
};

export const ANNUAL_PROGRESS_REPORT = {
    label: "Annual Progress Report",
    code: "APR"
};

const childLetterConst = [
    { label: "Child Letter", code: "CL" },
    INTRODUCTORY_LETTER,
    GIFT_ACKNOWLEDGEMENT_LETTER,
    THANK_YOU_LETTER,
    CHRISTMAS_CARD,
    FAREWELL_LETTER,
    ANNUAL_PROGRESS_REPORT,
    CHILD_EXPRESSION_WORKSHEET
];

export default childLetterConst;

// export {
//     CHILD_LETTER,
//     INTRODUCTORY_LETTER,
//     GIFT_ACKNOWLEDGEMENT_LETTER,
//     THANK_YOU_LETTER,
//     CHRISTMAS_CARD,
//     FAREWELL_LETTER,
//     ANNUAL_PROGRESS_REPORT
// };
